import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";

import { Container, Row, Col } from "reactstrap";
import { fields } from "../../common/lib/redux-fields";

import NavigationPrompt from "../components/NavigationPrompt/NavigationPrompt";
import ConfirmModal from "../components/ConfirmModal/ConfirmModal";

import { formFields, Form } from "./Form";

import { get } from "../../common/offer/actions";

class Edit extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { params, get } = this.props;

    const uid = params.uid;
    get({ uid });
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { apiHost, fields, params, map } = this.props;

    const uid = params.uid;
    const obj = map.get(uid);

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;
    const color = dirty ? "warning" : "primary";

    const cs = !obj ? " text-xs-center" : "";

    return (
      <div
        className={
          "panel panel-default panel-border-color panel-border-color-" +
            color +
            cs
        }
      >
        <div className="panel-heading panel-heading-divider">
          <div className="tools">
            {/*<i className="fa fa-plus" />*/}
          </div>
          <span className="panel-subtitle" />
        </div>

        <div className="panel-body">
          {obj
            ? <Form editForm params={params} obj={obj} />
            : <i className="edit-spinner fa fa-circle-o-notch fa-spin fa-2x" />}
          <NavigationPrompt when={dirty} message="" />
        </div>
      </div>
    );
  }
}

Edit.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Edit = fields(Edit, {
  path: "offerForm",
  fields: formFields
});

export default connect(
  state => ({
    apiHost: state.config.apiHost,
    map: state.offer.map,
    fields: state.fields
  }),
  { get }
)(Edit);



// WEBPACK FOOTER //
// ./src/browser/offer/Edit.js